export default function useUpdateEffect(callback, dependencies = []) {
    const mountedRef = React.useRef(false)

    React.useEffect(() => {
        if (!mountedRef.current) {
            mountedRef.current = true
            return
        }

        return callback()
    }, dependencies)
}
